import React from 'react';

import { ButtonIcon } from 'shared';
import { VARIANTS } from 'shared_DEPRECATED/components/Button';

type SendButtonProps = {
  disabled: boolean;
  children: React.ReactNode;
};

export const ChatFormSubmitButton = ({
  disabled,
  children,
}: SendButtonProps) => {
  return (
    <ButtonIcon
      aria-label="send chat message"
      type="submit"
      color={VARIANTS.PRIMARY}
      disabled={disabled}
      data-testid="chat-form-submit"
      rounded="full"
      flexShrink={0}
      size="md"
    >
      {children}
    </ButtonIcon>
  );
};
